import { useState } from "react";
import { toast } from "sonner";
import { Upload, FileText, Music, CheckCircle2 } from "lucide-react";
import { api, errMsg } from "../../lib/api";

const CHUNK = 2 * 1024 * 1024;

export function MaterialUpload({ material, onUploaded }) {
  const [pct, setPct] = useState(null);
  const upload = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    const uploadId = crypto.randomUUID();
    const total = Math.ceil(file.size / CHUNK);
    setPct(0);
    try {
      for (let i = 0; i < total; i++) {
        const fd = new FormData(); fd.append("upload_id", uploadId); fd.append("index", i); fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), file.name);
        await api.post("/files/upload/chunk", fd);
        setPct(Math.round(((i + 1) / total) * 95));
      }
      const { data } = await api.post("/files/upload/complete", { upload_id: uploadId, filename: file.name, total_chunks: total });
      setPct(100);
      onUploaded({ url: data.url, type: "file", filename: data.filename, file_id: data.id, size: data.size });
      toast.success(`${file.name} terunggah`);
    } catch (err) { toast.error(errMsg(err)); } finally { setTimeout(() => setPct(null), 800); e.target.value = ""; }
  };
  const isFile = material.type === "file" && material.file_id;
  const Icon = /\.(mp3|wav|m4a|ogg)$/i.test(material.filename || "") ? Music : FileText;
  return (
    <label className={`inline-flex items-center h-8 px-2 rounded-md border text-xs cursor-pointer shrink-0 ${isFile ? "border-emerald-300 bg-emerald-50 text-emerald-700" : "hover:border-slate-900"}`} title={isFile ? material.filename : "Unggah PDF/audio"} data-testid="material-upload-label">
      {pct != null ? <span className="font-mono w-16 text-center" data-testid="material-upload-progress">{pct}%</span> : isFile ? <><CheckCircle2 className="h-3.5 w-3.5 mr-1" /><Icon className="h-3.5 w-3.5 mr-1" /><span className="max-w-[90px] truncate">{material.filename}</span></> : <><Upload className="h-3.5 w-3.5 mr-1" />File</>}
      <input type="file" className="hidden" accept=".pdf,.mp3,.wav,.m4a,.ogg,.mp4,.png,.jpg,.jpeg,.webp,.pptx,.docx,.xlsx" onChange={upload} disabled={pct != null} data-testid="material-file-input" />
    </label>
  );
}

export const fileHref = (url) => (url && url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);
